import { IconProps } from './types';

export const IconFlashFilled = ({ size = 20, color = 'currentColor', ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
    <path d='M13 2L3 14H12L11 22L21 10H12L13 2Z' fill={color} stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
